const { toInt } = require('@/functions/transform');

class AbstractVerifoneResponseRecord {
    constructor() {
        /**
         * '0' - Success
         * '-nn' - Negative values are used to define error conditions.
         *
         * @type {?number}
         */
        this.result = null;

        /**
         * @type {string}
         */
        this.message = '';

        /**
         * A custom HTML string to display this record's message instead of the default message text.
         *
         * @type {?string}
         */
        this.messageHtml = null;

        /**
         * The raw message received from the terminal.
         *
         * @type {string}
         */
        this.rawResponse = '';
    }

    getHydrationMap() {
        return {
            result: {
                field: 1,
                transform: toInt,
            },
            message: {
                field: 18,
            },
            rawResponse: {},
        };
    }
}

module.exports = AbstractVerifoneResponseRecord;
